// Mapbox plugin for CDN version
const MapboxCDNPlugin = {
    install(Vue) {
        Vue.prototype.$mapbox = {
            // Async loadMapbox method for compatibility
            async loadMapbox() {
                if (typeof window.mapboxgl === 'undefined') {
                    throw new Error('Mapbox GL JS not loaded from CDN. Please check your internet connection.');
                }
                return window.mapboxgl;
            },

            // Direct access to mapboxgl
            get mapboxgl() {
                return window.mapboxgl;
            }
        };

        Vue.prototype.$mapboxHelpers = {
            // Set access token
            setAccessToken(token) {
                if (window.mapboxgl) {
                    window.mapboxgl.accessToken = token;
                }
            },

            // Create a new map instance
            createMap(container, options = {}) {
                const defaultOptions = {
                    style: 'mapbox://styles/mapbox/dark-v11',
                    center: [-74.5, 40],
                    zoom: 9,
                    ...options
                };

                return new window.mapboxgl.Map({
                    container,
                    ...defaultOptions
                });
            },

            // Add pipeline layer to map
            addPipelineLayer(map, data) {
                map.addSource('pipeline', {
                    type: 'geojson',
                    data: data
                });

                map.addLayer({
                    id: 'pipeline-route',
                    type: 'line',
                    source: 'pipeline',
                    layout: {
                        'line-join': 'round',
                        'line-cap': 'round'
                    },
                    paint: {
                        'line-color': '#00ff00',
                        'line-width': 3
                    }
                });
            }
        };
    }
};

export default MapboxCDNPlugin;